var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64945 10.0929H7.0013V7.50033H6.35315M7.0013 4.90773H7.00778M12.8346 7.50033C12.8346 10.722 10.223 13.3337 7.0013 13.3337C3.77964 13.3337 1.16797 10.722 1.16797 7.50033C1.16797 4.27866 3.77964 1.66699 7.0013 1.66699C10.223 1.66699 12.8346 4.27866 12.8346 7.50033Z",
    stroke: "#D97706",
    strokeWidth: 1.39167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b8020a5f2357fa9b816cacbea19e7f68.svg";
export { ForwardRef as ReactComponent };